export default "__VITE_ASSET__ba39fb32__"